class MagicTextAnimate extends HTMLElement {
  connectedCallback() {
    this.animationType = this.getAttribute("animation") || "blur-in";
    this.splitType = this.getAttribute("split-by") || "word";
    this.staggerDelay = parseFloat(this.getAttribute("stagger")) || 0.05;

    this.classList.add("magic-text-animate", `animation-${this.animationType}`);

    const init = () => {
      // Parse child nodes and wrap text
      this.processInitialNodes(this);

      // Intersection Observer to trigger the effect
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add("is-visible");
              this.observer.unobserve(this);
            }
          });
        },
        { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
      );

      this.observer.observe(this);
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(init);
    } else {
      setTimeout(init, 50);
    }
  }

  processInitialNodes(root) {
    let wordIndex = 0;

    const walkNodes = (el) => {
      const children = Array.from(el.childNodes);

      children.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          if (!text.trim()) return;

          const fragment = document.createDocumentFragment();

          if (this.splitType === "word") {
            // Split by words but preserve whitespace correctly
            const words = text.split(/(\s+)/);

            words.forEach((word) => {
              if (word.trim()) {
                const span = document.createElement("span");
                span.className = "magic-word";
                span.style.setProperty("--index", wordIndex++);
                span.textContent = word;
                fragment.appendChild(span);
              } else {
                fragment.appendChild(document.createTextNode(word));
              }
            });
          } else if (this.splitType === "character") {
            const chars = text.split(/(?=\s)|(?<=\s)|(?:)/);
            chars.forEach((char) => {
              if (char.trim()) {
                const span = document.createElement("span");
                span.className = "magic-word";
                span.style.setProperty("--index", wordIndex++);
                span.textContent = char;
                fragment.appendChild(span);
              } else {
                fragment.appendChild(document.createTextNode(char));
              }
            });
          }

          node.parentNode.replaceChild(fragment, node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          // If it's already a magic-word, ignore
          if (node.classList && node.classList.contains("magic-word")) return;
          walkNodes(node);
        }
      });
    };

    walkNodes(root);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get("magic-text-animate")) {
  customElements.define("magic-text-animate", MagicTextAnimate);
}
